import { jsx } from 'react/jsx-runtime';
import { c as cx } from './index-tZvMCc77.js';
import { forwardRef } from 'react';
import { u as useLayoutPropsUtil } from './useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js';

import './Text-hQPAQBGP.css';const headline = "_headline_1057f_3";
const eyebrow = "_eyebrow_1057f_16";
const bodytext = "_bodytext_1057f_29";
const xlarge = "_xlarge_1057f_74";
const large = "_large_1057f_78";
const medium = "_medium_1057f_82";
const small = "_small_1057f_85";
const subdued = "_subdued_1057f_103";
const inline = "_inline_1057f_106";
const styles = {
	headline: headline,
	eyebrow: eyebrow,
	bodytext: bodytext,
	xlarge: xlarge,
	large: large,
	medium: medium,
	small: small,
	subdued: subdued,
	inline: inline
};

const Text = forwardRef((props, ref) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
  if (props.variant === "headline") {
    const {
      variant: _,
      children,
      className,
      el: HeadlineElement,
      size = "medium",
      style,
      ...rest
    } = componentProps;
    const TextClasses = cx(styles["headline"], className, {
      [styles[`${size}`]]: size
    });
    const styleCombined = { ...style, ...layoutStyles };
    return (
      // @ts-expect-error ts(2604) HeadlineElement will work as element tag
      /* @__PURE__ */ jsx(
        HeadlineElement,
        {
          ref,
          className: TextClasses,
          "data-anv": "text",
          style: styleCombined,
          ...rest,
          children
        }
      )
    );
  } else if (props.variant === "eyebrow") {
    const {
      variant: _,
      children,
      className,
      size = "medium",
      style,
      ...rest
    } = componentProps;
    const TextClasses = cx(styles["eyebrow"], className, {
      [styles[`${size}`]]: size
    });
    const styleCombined = { ...style, ...layoutStyles };
    return /* @__PURE__ */ jsx(
      "span",
      {
        ref,
        className: TextClasses,
        "data-anv": "text",
        style: styleCombined,
        ...rest,
        children
      }
    );
  } else {
    const {
      variant: _,
      children,
      className,
      subdued,
      inline,
      style,
      size = "medium",
      ...rest
    } = componentProps;
    const TextClasses = cx(styles["bodytext"], className, {
      [styles[`${size}`]]: size,
      [styles["subdued"]]: subdued,
      [styles["inline"]]: inline
    });
    const styleCombined = { ...style, ...layoutStyles };
    if (inline) {
      return /* @__PURE__ */ jsx(
        "span",
        {
          ref,
          className: TextClasses,
          "data-anv": "text",
          style: styleCombined,
          ...rest,
          children
        }
      );
    } else {
      return /* @__PURE__ */ jsx(
        "p",
        {
          ref,
          className: TextClasses,
          "data-anv": "text",
          style: styleCombined,
          ...rest,
          children
        }
      );
    }
  }
});
Text.displayName = "Text";

export { Text as T };
//# sourceMappingURL=Text-hQPAQBGP-CEIjvHcA.js.map
